import { Component } from '@angular/core';
import { Message, PrimeNGConfig, Translation } from 'primeng/api';
import { map } from 'rxjs';
import { getTranslationProvider } from './core/i18n/getTranslationProvider';
import { TranslatableComponent } from './core/i18n/TranslatableComponent';
import { TranslatableStringType } from './core/i18n/types';
import { i18nFeature } from './core/state/i18n/i18n.reducers';
import { ToastActions } from './core/state/toast/toast.actions';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  providers: [getTranslationProvider('AppComponent')],
})
export class AppComponent extends TranslatableComponent {
  constructor(private config: PrimeNGConfig) {
    super();

    this.store
      .select(i18nFeature.selectPrimeng)
      .pipe(map((translations) => this.splitArrayishValues(translations)))
      .subscribe((translations: Translation) => {
        this.config.setTranslation(translations);
      });
  }

  private splitArrayishValues(translations: Record<string, TranslatableStringType>) {
    const result: Translation = {};

    Object.entries(translations).forEach(([key, value]) => {
      if (value.includes(',')) {
        result[key] = value.split(',').map((v) => v.trim());
      } else {
        result[key] = value;
      }
    });

    return result;
  }

  handleToastButtonClick(message: Message) {
    message.data?.button?.click?.();
    this.store.dispatch(ToastActions.clearsAllToastMessages({}));
  }
}
